import React from 'react';
import { StyleSheet, View } from 'react-native'
import { ThemedShared } from 'styles/themed'
import _ from 'lodash'
import isEqual from 'react-fast-compare'
import { themedButtonContainerStyle } from 'styles/components/atoms/ThemedButtonContainer'
import HelperString from 'utils/helper-string'

const ThemedButtonContainer = ({ children, align = 'center', style = {}, padding = true, fill = false }) => {
	
	const viewStyle = [
		fill ? themedButtonContainerStyle.viewFill : themedButtonContainerStyle.view,
		{
			alignItems: align,
			flexDirection: 'row',
			justifyContent: 'space-evenly',
		},
		padding ? ThemedShared.paddingSmall : {},
		style,
	]
	
	let content = children
	if( _.isArray( children ) ) {
		content = [];
		
		_.forEach( children, ( value, key ) => {
			content.push(
				<View
					key={ HelperString.hash('themed-button-view', key ) }
					style={ styles.button }>
					
					{ value }
				</View>
			)
			
			if( key < _.size( children ) ) {
				content.push(
					<View
						key={ HelperString.hash('themed-button-spacer', key ) }
						style={ styles.spacer }
					/>
				)
			}
		})
	}
	
	return (
		<View style={ viewStyle }>
			{ content }
		</View>
	)
}

const styles = StyleSheet.create({
	button: { flex: 1 },
	spacer: { width: 5 },
});

export default React.memo( ThemedButtonContainer, isEqual );
